export default __webpack_public_path__ + "static/media/colored-invocation.6aba9fb4.svg";